













































import VueOptions from '@utils/VueOptions'
import RequestButton from '@/components/RequestButton'

settings =
  name: 'CreateWizard'

  vue:
    props: ['eventWizard', 'actions']

    computed:
      sponsorSet: -> @ctxEventSet(@eventWizard).sponsor_set || []
      hasSponsorSet: -> @sponsorSet.length > 0
      primaryDomains: -> @ctxEventSet(@eventWizard).primary_sponsor_set_domains || []

    methods:
      hiAddSponsorSetTrigger: -> @actions.addSponsorSetTrigger()
      hiRemoveSponsorSetTrigger: (brand) -> @actions.removeSponsorSetTrigger brand
      hiMarkSponsorSetAsPrimary: (domain, ev) -> @actions.markSponsorSetAsPrimary domain, ev
      hiUnmarkSponsorSetAsPrimary: (domain, ev) -> @actions.unmarkSponsorSetAsPrimary domain, ev

export default VueOptions.vue settings
